import { render, staticRenderFns } from "./CreateProviderRegion.vue?vue&type=template&id=0efbcfb9"
import script from "./CreateProviderRegion.vue?vue&type=script&lang=js"
export * from "./CreateProviderRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports